import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/r/$code')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/room/$code', params: { code: params.code }, replace: true });
  },
});
